import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

export default class ReactivateAlertRequest extends BaseServiceRequest {
    constructor(alertID) {
        super();

        super.addRequestUri("reactivate.pb");
        super.addPathParameter(alertID.toString());
    }

    getMethod() {
        return HttpMethodType.PUT;
    }

    getSubSystem() {
        return SubSystemType.ALERTS;
    }

    getMessageName() {
        return "Response";
    }

}